import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { Page } from '../model/Page';
import { Datamanager } from '../model/Datamanager';
import { BatchModel } from '../model/BatchModel';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class ExportImportService {
    
    constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

    initExportAppsForm(page: number, size: number) {
        let reqParams = `?page=${page}&size=${size}`;
        return this.httpClient.get<{
          lotteryList: {[key: number]: string}, 
          datamanagerList: Page<Datamanager>
          status: string, 
          errorMessage: string
        }>(ApiUrls.exportAppsInitFormUrl + reqParams);
    }

    initExportPhotosForm() {
        return this.httpClient.get<{
            lotteryList: {[key: number]: string}, 
            status: string, 
            errorMessage: string
          }>(ApiUrls.exportPhotosInitFormUrl);
    }

    fetchBatchWiseLotteryPhotos(key: number) {
        return this.httpClient.get<BatchModel[]>(ApiUrls.fetchBatchWiseLotteryPhotosUrl.replace('{lotteryKey}', key.toString()));
    }

    exportApplications(lotteryKey: number) {
        return this.httpClient.post<{
            status: string, 
            errorMessage: string
          }>(ApiUrls.exportAppsUrl.replace('{lotteryKey}', lotteryKey.toString()), null);
    }

    importResults(lotteryKey: number, base64: string | ArrayBuffer, fileName: string) {
        return this.httpClient.post<{
            status: string, 
            errorMessage: string
          }>(ApiUrls.importResultsUrl.replace('{lotteryKey}', lotteryKey.toString()), {
            bas64Data: base64, 
            fileName: fileName
        });
    }

        

        
 


  

    initImportResultsForm(page: number, size: number) {
        let reqParams = `?page=${page}&size=${size}`;
        return this.httpClient.get<{
          lotteryList: {[key: number]: string}, 
          datamanagerList: Page<Datamanager>
          status: string, 
          errorMessage: string
        }>(ApiUrls.importResultsInitFormUrl + reqParams);
    }

    downloadENC(key: number) {
        return this.httpClient.post<FileResponseModel>(ApiUrls.downloadENCUrl.replace('{key}', key.toString()), null);
    }

    downloadPol( applicationNo: string) {
        return this.httpClient.post<FileResponseModel>(
            ApiUrls.downloadPolUrl
            .replace('{applicationNo}', applicationNo)
           , null);
    }      

    downloadPhotos(lotteryKey: number, batchName: string, start: number, end: number) {
        return this.httpClient.post<FileResponseModel>(
            ApiUrls.downloadPhotosUrl
            .replace('{lotteryKey}', lotteryKey.toString())
            .replace('{batchName}', batchName)
            .replace('{start}', start.toString())
            .replace('{end}', end.toString())
            , null);
    }      
    
    printExportApplicationsHashCode(key: number) {
        return this.httpClient.post<FileResponseModel>(ApiUrls.printExportApplicationsHashCodeUrl.replace('{key}', key.toString()), null);
    }

    async successToast(msg) {
        await this._snackBar.open(
            msg,
            "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
            }
        );
    }

    async errorToast(errorMessage: string, dur?: number) {
        await this._snackBar.open(errorMessage, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "error-toast",
            duration: dur ? dur : 3 * 1000,
            }
        );
    }
}